import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _typeof from "/Users/aalzahr/mwc-components-common/node_modules/@babel/runtime-corejs2/helpers/esm/typeof";
/**
 * remove null values from component config
 * @param {object} config 
 * @returns {array}
 */

function removeNullValues(config) {
  if (Array.isArray(config) || _typeof(config) !== 'object') {
    return config;
  }

  if (!config) {
    return undefined;
  }

  return Object.keys(config).reduce(function (acc, next) {
    var validProp = removeNullValues(config[next]);

    if (typeof validProp !== 'undefined') {
      acc[next] = validProp;
    }

    return acc;
  }, {});
}

var methods = {
  /**
   * get merged MWC component configuration
   * @returns {object} component configuration
   */
  getComponentConfig: function getComponentConfig() {
    if (!this.mwcId) return null;
    var result;
    var configuration = window.mwc ? window.mwc.configuration : null;
    var parsedConfig = typeof this.config === 'string' ? JSON.parse(this.config) : this.config || configuration.injectedConfig && configuration.injectedConfig[this.mwcId];

    if (configuration) {
      result = configuration.getConfig(this.mwcId, removeNullValues(this.defaultConfig), parsedConfig);
    }

    return result;
  },

  /**
   * Number formatting for internationalization
   * @param  {string} args label to translate 
   * @returns {string}
   */
  $t: function $t() {
    var _this$$mwc$labeller;

    return (_this$$mwc$labeller = this.$mwc.labeller).getLabel.apply(_this$$mwc$labeller, arguments);
  },

  /**
   * Number formatting for internationalization
   * @param {number} x number to format
   * @param {string} format ex: 'number'
   * @returns {string}
   */
  $nf: function $nf(x, format) {
    return this.$mwc.formatter.number(x, format || 'number');
  },

  /**
   * Currency formatting for internationalization
   * @param {number} x number to format
   * @param {string} format ex: 'currency'
   */
  $cf: function $cf(x, format) {
    return this.$mwc.formatter.currency(x, format || 'currency');
  },

  /**
   * Date formatting for internationalization
   * @param {number} x number to format
   * @param {string} format ex: 'date'
   */
  $df: function $df(x, format) {
    return this.$mwc.formatter.number(x, format || 'date');
  }
}; // We need access to "this" which doesn't work with instance funcs...
// this also hides functionality from non-mwc components

export default (function (vm) {
  Object.keys(methods).forEach(function (method) {
    vm.$mwc[method] = methods[method].bind(vm); // eslint-disable-line
  });
});
